'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.setDoLocation = setDoLocation;
exports.setStartY = setStartY;
exports.setIsSearched = setIsSearched;
exports.setMajorName = setMajorName;
exports.reloadCUMajorList = reloadCUMajorList;
exports.loadMoreCUMajorList = loadMoreCUMajorList;
var RELOAD_CUMAJOR_LIST = 'bp/cumajor/home/RELOAD_CUMAJOR_LIST';
var RELOAD_CUMAJOR_LIST_SUCCESS = 'bp/cumajor/home/RELOAD_CUMAJOR_LIST_SUCCESS';
var RELOAD_CUMAJOR_LIST_FAIL = 'bp/cumajor/home/RELOAD_CUMAJOR_LIST_FAIL';

var LOAD_MORE_CUMAJOR_LIST = 'bp/cumajor/home/LOAD_MORE_CUMAJOR_LIST';
var LOAD_MORE_CUMAJOR_LIST_SUCCESS = 'bp/cumajor/home/LOAD_MORE_CUMAJOR_LIST_SUCCESS';
var LOAD_MORE_CUMAJOR_LIST_FAIL = 'bp/cumajor/home/LOAD_MORE_CUMAJOR_LIST_FAIL';

var SET_MAJORNAME = 'bp/cumajor/home/SET_MAJORNAME';
var SET_ISSEARCHED = 'bp/cumajor/home/SET_ISSEARCHED';
var SET_DO_LOCATION = 'bp/cumajor/home/SET_DO_LOCATION';
var SET_STARTY = 'bp/cumajor/home/SET_STARTY';

var initState = {
    cumajorList: [],
    pager: {},
    searchName: '',
    isSearched: false,
    hasInited: false,
    doLocation: false,
    startY: 0
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
    var action = arguments[1];

    switch (action.type) {
        case RELOAD_CUMAJOR_LIST:
            return _extends({}, state, {
                cumajorList: [],
                pager: {}
            });
        case RELOAD_CUMAJOR_LIST_SUCCESS:
            if (!action.result.data.success) {
                return _extends({}, state, {
                    cumajorList: [],
                    pager: null,
                    isSearched: true,
                    hasInited: true
                });
            }
            if (action.query.name != null && action.query.name != "") {
                return _extends({}, state, {
                    cumajorList: action.result.data.data,
                    pager: action.result.data.pager,
                    isSearched: true,
                    hasInited: true
                });
            }
            return _extends({}, state, {
                cumajorList: action.result.data.data,
                pager: action.result.data.pager,
                isSearched: true,
                hasInited: true
            });
        case LOAD_MORE_CUMAJOR_LIST_SUCCESS:
            {
                if (!action.result.data.success) {
                    return state;
                }
                var res = _extends({}, state, {
                    pager: action.result.data.pager
                });
                res.cumajorList = res.cumajorList.concat(action.result.data.data);
                return res;
            }
        case SET_MAJORNAME:
            return _extends({}, state, {
                searchName: action.searchName
            });
        case SET_ISSEARCHED:
            return _extends({}, state, {
                isSearched: action.isSearched
            });
        case SET_DO_LOCATION:
            return _extends({}, state, {
                doLocation: action.doLocation
            });
        case SET_STARTY:
            return _extends({}, state, {
                startY: action.startY
            });
        default:
            return state;
    }
}

function setDoLocation(value) {
    return {
        type: SET_DO_LOCATION,
        doLocation: value
    };
}

function setStartY(y) {
    return {
        type: SET_STARTY,
        startY: y
    };
}

function setIsSearched(value) {
    return {
        type: SET_ISSEARCHED,
        isSearched: value
    };
}

function setMajorName(searchName) {
    return {
        type: SET_MAJORNAME,
        searchName: searchName
    };
}

function _reloadCUMajorList(query) {
    return {
        types: [RELOAD_CUMAJOR_LIST, RELOAD_CUMAJOR_LIST_SUCCESS, RELOAD_CUMAJOR_LIST_FAIL],
        promise: function () {
            function promise(client) {
                return client.post('/api/major/list', query);
            }

            return promise;
        }(),
        query: query
    };
}

function _loadMoreCUMajorList(query, callback) {
    return {
        types: [LOAD_MORE_CUMAJOR_LIST, LOAD_MORE_CUMAJOR_LIST_SUCCESS, LOAD_MORE_CUMAJOR_LIST_FAIL],
        promise: function () {
            function promise(client) {
                return client.post('/api/major/list', query);
            }

            return promise;
        }(),
        afterSuccess: function () {
            function afterSuccess(dispatch, getState, response) {
                if (callback) {
                    callback();
                }
            }

            return afterSuccess;
        }()
    };
}

function _createQuery(state) {
    var query = {
        name: state.searchName,
        page: state.pager ? state.pager.page + 1 : 1,
        size: 20
    };
    return query;
}

function reloadCUMajorList(searchName) {
    return function (dispatch, getState) {

        dispatch(setMajorName(searchName ? searchName : ''));
        var state = getState().cumajorHome;
        state.pager = null;
        var query = _createQuery(state);
        dispatch(_reloadCUMajorList(query));
    };
}
// export function reloadCUMajorList(searchName, mustInit = false) {
//     return (dispatch, getState) => {
//         if (mustInit || !getState().cumajorHome.hasInited) {
//             dispatch(setIsSearched(false));
//             dispatch(setMajorName(searchName ? searchName : ''));
//             const state = getState().cumajorHome;
//             state.pager = null;
//             const query = _createQuery(state);
//             dispatch(_reloadCUMajorList(query));
//             dispatch(setDoLocation(false));
//             dispatch(setStartY(0));
//         } else {
//             dispatch(setDoLocation(true));
//         }
//     }
// }

function loadMoreCUMajorList(callback) {
    return function (dispatch, getState) {
        var state = getState().cumajorHome;
        if (state.pager && state.pager.page && state.pager.page == state.pager.totalPages) {
            return;
        }
        var query = _createQuery(state);
        dispatch(_loadMoreCUMajorList(query, callback));
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/cumajor/cumajorHome.js
// module id = 461
// module chunks = 0